<template>
    <div>
        <base-header class="pb-6"></base-header>
        <div class="container-fluid mt--6">
            <div class="card">
                <div class="card-header border-0">
                    <div class="row">
                        <div class="col-sm-8">
                        <h3 class="mb-0">Evaluación: #{{ evaluation.uuid }} </h3>
                        </div>
                        <div class="col-sm-4">
                        <h3 class="mb-0">{{ evaluation.points }} PTS</h3>
                        </div>
                    </div>
                </div>
                <div class="row starter-page">
                    <div class="container-fluid">
                        <el-table
                        class="table-responsive table-flush"
                        header-row-class-name="thead-light"
                        row-key="id"
                        :data="categories"
                        >
                        <el-table-column label="Categoria" prop="name"  min-width="200px" sortable>
                            <template v-slot="{row}">{{ row.name}}</template>
                        </el-table-column>
                        <el-table-column label="Observaciones" prop="observation"  min-width="200px" sortable>
                            <template v-slot="{row}">{{ row.observation }}</template>
                        </el-table-column>
                        <el-table-column label="Estado" prop="status"  min-width="200px" sortable>
                            <template v-slot="{row}">{{ row.status == 'done' ? 'Completo' : 'Pendiente' }}</template>
                        </el-table-column>
                        <el-table-column label="Puntos" prop="points"  min-width="200px" sortable>
                            <template v-slot="{row}" >
                                <div v-if="row.status == 'done'">
                                    {{ row.points }} PTS
                                </div>
                                <div v-else>
                                    0 PTS
                                </div>
                                </template>
                        </el-table-column>
                        <el-table-column label="Accion" prop="id"  min-width="200px" sortable>
                        <template v-slot="{row}">
                            <base-button
                            type="primary"
                            @click="showCategory(row.id)"
                            >
                            <i class="far fa-file-pdf"></i> Ver
                            </base-button>
                            </template>
                        </el-table-column>    
                        </el-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {Dropdown, DropdownItem, DropdownMenu, Table, TableColumn, Tooltip} from "element-ui";
import axios from "axios";

export default {
    name: "Categorias",
    components: {
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    },
    data() {
        return {
        categories: [],
        evaluation: ''
        };
    },
    created() {
    this.getEvaluation()
    },
    methods: {
        getEvaluation(){
            axios.get(`/evaluacion/${this.$route.params.id}`).then((response => {
                this.evaluation = response.data
                this.categories = this.evaluation.areas
            }))
        },
        showCategory(id){
            this.$router.push({ name: 'evaluacion_categoria_faq', params: {id:this.$route.params.id, faq: id } })
        }
    },
}
</script>
<style lang="scss" scoped>

</style>